export default "__VITE_ASSET__c2f19cbb__"